<div class="wrapper" *ngIf="(pending$ | async) === pendingState.success">
  <div class="back-link-container confinement">
    <a routerLink="/navigation" class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'NAVBAR.MY_ACCOUNT' | translate }}</a
    >
  </div>
  <mat-card class="content-box confinement">
    <mat-card-title class="mat-title two-columns-grid">
      <div>
        <span>{{ 'ACCOUNT.PAYMENT_METHODS' | translate }}</span>
      </div>
      <div class="align-right" style="display: flex; justify-content: flex-end">
        @if (maxPaymentMethodsAllowed && paymentMethods.length < maxPaymentMethodsAllowed) {
        <button mat-button class="hide-on-xs" routerLink="/navigation/account/payment-methods/new">
          <span class="add-payment-method-button-info">
            {{ 'ACCOUNT.ADD_PAYMENT_METHOD.BUTTON_INFO' | translate }}
          </span>
          <mat-icon color="primary">add</mat-icon>
<!--          <a mat-icon-button color="primary"></a>-->
        </button>
        }

        <button mat-fab color="primary" class="show-on-xs" routerLink="/navigation/account/payment-methods/new">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-card-title>
    <mat-card-content class="two-columns-grid">
      <ng-container *ngFor="let paymentMethod of paymentMethods; let i = index">
        <cover-payment-method-card
          [sessionId]="c4SessionId"
          [paymentMethod]="paymentMethod"
          [adrGr]="adrGr"
          [personNr]="personNr"
        ></cover-payment-method-card>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
<div class="spinner" *ngIf="(pending$ | async) === pendingState.pending">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="(pending$ | async) === pendingState.failed" class="wrapper">
  <mat-card class="content-box confinement">
    <mat-card-title class="error-text">
      {{ 'ERROR.PAYMENT_METHODS' | translate }}
    </mat-card-title>
    <mat-card-content class="error-text">
      {{ 'ERROR.DESCRIPTION' | translate }}
    </mat-card-content>
  </mat-card>
</div>
